import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import Image from 'next/image';
/* eslint-disable-next-line */

export function EmptyResults(props) {
  return _jsx("div", {
    className: "text-center",
    children: _jsx(Image, {
      src: "/_mp-images/empty_results.png",
      width: props.context.isMobileView ? 300 : 500,
      height: props.context.isMobileView ? 300 : 500,
      alt: ""
    })
  });
}
export default EmptyResults;